import { Module } from '@nestjs/common';
import { AppController } from './app.controller';
import { AppService } from './app.service';
import { RawMaterialGrnModule } from './raw-material-grn/raw-material-grn.module';
import { IndentModule } from './indent/indent.module';
import { TypeOrmModule } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';
import { Indent } from './indent/indent.entity';
import { Grn } from './raw-material-grn/raw-material-grn.entity';
import { HaverstReport } from './indent/harvest-report.entity';
import { RmVehicleInspection } from './raw-material-grn/rm-vehicle-inspection.entity';
import { RmEvaluation } from './raw-material-grn/rm-evaluation.entity';
import { RmEvaluationSamples } from './raw-material-grn/rm-evaluation-samples.entity';
import { RmAntiBioticsTest } from './raw-material-grn/rm-antibiotics-report.entity';
import { IndentItems } from './indent/indent-items.entity';
import { GrnItems } from './raw-material-grn/raw-material-grn-items.entity';
import { RmIndentQtyLimitModule } from './rm-indent-qty-limit/rm-indent-qty-limit.module';
import { RmIndentQtyLimit } from './rm-indent-qty-limit/rm-indent-qty-limit.entity';
import { RMReWeighingEntity } from './indent/rm-re-weighing/rm-re-weighing.entity';
import { GrnItemDefects } from './raw-material-grn/grn-item-defects.entity';
@Module({
  imports: [
    TypeOrmModule.forRoot({
      type: 'mysql',
      host: appSettings.dbhost,
      port: 3306,
      username: appSettings.dbuser,
      password: appSettings.dbpassword,
      database: appSettings.rm_procure_db,
      entities: [
        Indent, IndentItems, Grn, HaverstReport, RmIndentQtyLimit, RmVehicleInspection, RmEvaluation, RmEvaluationSamples, RmAntiBioticsTest, GrnItems, RMReWeighingEntity, GrnItemDefects
      ],
      // synchronize: mastersConfigs.sync,
      synchronize: false,
      logging: true,
      // logger: new QueryLogger(new PinoLogger({ pinoHttp: { level: mastersConfigs.loggingMode } })),/
    }
    ),
    RawMaterialGrnModule, IndentModule, RmIndentQtyLimitModule],
  controllers: [AppController],
  providers: [AppService],
})
export class AppModule { }
